/* global axios */
import ApiClient from './ApiClient';

class MetaBusinessAccountsAPI extends ApiClient {
  constructor() {
    super('meta_business_accounts', { accountScoped: true });
  }

  oauthUrl(redirectUri) {
    return axios.post(`${this.url}/oauth_url`, { redirect_uri: redirectUri });
  }

  callback(params) {
    return axios.post(`${this.url}/callback`, params);
  }

  assets(id) {
    return axios.get(`${this.url}/${id}/assets`);
  }

  syncAssets(id) {
    return axios.post(`${this.url}/${id}/sync_assets`);
  }

  updateAssets(id, assetIds) {
    return axios.patch(`${this.url}/${id}/assets`, { asset_ids: assetIds });
  }

  reconnect(id, redirectUri) {
    return axios.post(`${this.url}/${id}/reconnect`, {
      redirect_uri: redirectUri,
    });
  }

  analytics() {
    return axios.get(`${this.url}/analytics`);
  }

  conversionEvents() {
    return axios.get(
      `${this.baseUrl()}/meta_business_accounts/conversion_events`
    );
  }

  eventMappings() {
    return axios.get(`${this.baseUrl()}/meta_business_accounts/event_mappings`);
  }
}

export default new MetaBusinessAccountsAPI();
